import React from "react";
import Button from "components/foundation/Button";
import Modal from "components/foundation/Modal/Modal";
import { DocumentDuplicateAttachmentDto } from "apis/data-contracts";
import styled from "styled-components";

interface ArchivesDuplicateModalProps {
  duplicateFileList: DocumentDuplicateAttachmentDto[];
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
}

const ArchivesDuplicateModal = ({
  duplicateFileList,
  onConfirm,
}: ArchivesDuplicateModalProps) => {
  return (
    <Modal.Layout>
      <Modal.Title>동일한 문서가 이미 존재합니다.</Modal.Title>
      <Modal.Content>
        {duplicateFileList.map((file) => (
          <DocumentInfoStyle key={file.uuid}>{file.fileName}</DocumentInfoStyle>
        ))}
      </Modal.Content>
      <ModalFooterStyle>
        <Button variant="primary" size="large" onClick={onConfirm}>
          확인
        </Button>
      </ModalFooterStyle>
    </Modal.Layout>
  );
};

export default ArchivesDuplicateModal;

const ModalFooterStyle = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DocumentInfoStyle = styled.div`
  color: ${({ theme }) => theme.color.skyblue[700]};
`;
